import { render } from "./Notifications.vue?vue&type=template&id=1ee69a20&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=1ee69a20&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ee69a20"

export default script